import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CuestionariosService } from '../services/cuestionarios.service';

@Component({
  selector: 'app-nueva-opcion-dialog',
  templateUrl: './nueva-opcion-dialog.component.html',
  providers: [MessageService]
})
export class NuevaOpcionDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() cuestionario: any = null;
  @Input() preguntaSeleccionada: any = null;
  @Input() opcionSeleccionada: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();

  form: FormGroup;
  loading: boolean = false;
  esEdicion: boolean = false;
  displayScriptDialog: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {
    this.form = this.fb.group({
      sClaveCues: [{ value: '', disabled: true }, Validators.required],
      iNumPreg: [{ value: '', disabled: true }, Validators.required],
      iNumOpcion: ['', Validators.required],
      sValorStr: ['', Validators.required],
      dRango1: [0],
      dRango2: [0],
      iScore: [0],
      iSigPreg: [0]
    });
  }

  ngOnInit(): void {
    this.cargarDatosIniciales();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Cambios detectados:', changes);
    if (changes['displayDialog'] && this.displayDialog) {
      this.cargarDatosIniciales();
    }
  }

  cargarDatosIniciales(): void {
    console.log('Cargando datos iniciales:', {
      cuestionario: this.cuestionario,
      preguntaSeleccionada: this.preguntaSeleccionada,
      opcionSeleccionada: this.opcionSeleccionada
    });

    if (this.cuestionario && this.preguntaSeleccionada) {
      this.form.patchValue({
        sClaveCues: this.cuestionario.sClaveCues,
        iNumPreg: this.preguntaSeleccionada.iNumPreg
      });

      if (this.opcionSeleccionada) {
        console.log('Modo edición activado');
        this.esEdicion = true;
        this.form.get('iNumOpcion')?.disable();
        this.cargarDatosOpcion();
      } else {
        this.form.get('iNumOpcion')?.enable();
      }
    }
  }

  cargarDatosOpcion(): void {
    if (this.opcionSeleccionada) {
      const request = {
        que: 5,
        tope: "",
        sClaveCues: this.cuestionario.sClaveCues,
        iNumPreg: this.preguntaSeleccionada.iNumPreg,
        iNumOpcion: this.opcionSeleccionada.iNumOpcion,
        sValorStr: "",
        dRango1: 0,
        dRango2: 0,
        iScore: 0,
        iSigPreg: 0
      };

      this.loading = true;
      this.cuestionariosService.getOpciones(request).subscribe({
        next: (response) => {
          if (response.success && response.data.length > 0) {
            const opcion = response.data[0];
            this.opcionSeleccionada = {
              iNumOpcion: opcion.iNumOpcion,
              ...opcion
            };
            this.form.patchValue({
              iNumOpcion: opcion.iNumOpcion,
              sValorStr: opcion.sValorStr,
              dRango1: opcion.dRango1,
              dRango2: opcion.dRango2,
              iScore: opcion.iScore,
              iSigPreg: opcion.iSigPreg
            });
          }
        },
        error: (error) => {
          console.error('Error al cargar datos de la opción:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los datos de la opción'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.loading = true;
      const formValue = this.form.getRawValue();
      
      const request = {
        que: this.esEdicion ? 2 : 1,
        tope: "",
        sClaveCues: this.cuestionario.sClaveCues,
        iNumPreg: this.preguntaSeleccionada.iNumPreg,
        iNumOpcion: formValue.iNumOpcion,
        sValorStr: formValue.sValorStr,
        dRango1: formValue.dRango1,
        dRango2: formValue.dRango2,
        iScore: formValue.iScore,
        iSigPreg: formValue.iSigPreg
      };

      console.log('Enviando request:', request);

      this.cuestionariosService.guardarOpcion(request).subscribe({
        next: (response) => {
          if (response.success && response.data.error === "0") {
            this.messageService.add({
              severity: 'success',
              summary: 'Éxito',
              detail: this.esEdicion ? 'Opción actualizada correctamente' : 'Opción guardada correctamente'
            });
            this.onDialogClosed();
            this.onHide.emit({ refresh: true });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: this.esEdicion ? 'No se pudo actualizar la opción' : 'No se pudo guardar la opción'
            });
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: this.esEdicion ? 'No se pudo actualizar la opción' : 'No se pudo guardar la opción'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
    }
  }

  limpiarFormulario(): void {
    this.form.reset({
      sClaveCues: this.cuestionario?.sClaveCues || '',
      iNumPreg: this.preguntaSeleccionada?.iNumPreg || '',
      dRango1: 0,
      dRango2: 0,
      iScore: 0,
      iSigPreg: 0
    });
    this.esEdicion = false;
    this.opcionSeleccionada = null;
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
    this.limpiarFormulario();
  }

  openScriptDialog(): void {
    if (!this.cuestionario || !this.preguntaSeleccionada || !this.opcionSeleccionada) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede abrir el diálogo de scripts sin una opción seleccionada'
      });
      return;
    }
    console.log('Abriendo diálogo de scripts con:', {
      cuestionario: this.cuestionario,
      pregunta: this.preguntaSeleccionada,
      opcion: this.opcionSeleccionada
    });
    this.displayScriptDialog = true;
  }

  onScriptDialogClosed(event: {refresh: boolean}): void {
    this.displayScriptDialog = false;
    if (event.refresh) {
      // Si necesitas refrescar algo cuando se cierra el diálogo de script
    }
  }
} 